import React from "react";
import Header from "../../components/marketing/pageSections/userProfile/Header";

const BodyUserProfile = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default BodyUserProfile;
